import { useEffect, useState } from "react";

// Articles imported from the original luxveritae.com blog, served as static JSON from /public/journal.
const fmt = (d) => (d ? new Date(`${d}T12:00:00`).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "");
const sub = (s) => (typeof s === "string" ? s.replace(/CO2\b/g, "CO₂") : s);
const withDate = (a) => ({ ...a, title: sub(a.title), dek: sub(a.dek), excerpt: sub(a.excerpt), body: sub(a.body), date: fmt(a.date) });
const API = `${process.env.REACT_APP_BACKEND_URL}/api/journal`;
const getJson = (url) => fetch(url).then((r) => (r.ok ? r.json() : null)).catch(() => null);

export const useJournalArchive = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    let live = true;
    // Newest AI-written posts (API) first, then the imported archive.
    Promise.all([getJson(API), getJson("/journal/index.json")]).then(([fresh, archive]) => {
      const all = [...(Array.isArray(fresh) ? fresh : []), ...(Array.isArray(archive) ? archive : [])];
      if (live) setItems(all.map(withDate));
    });
    return () => { live = false; };
  }, []);
  return items;
};

export const useJournalPost = (slug, skip) => {
  const [state, setState] = useState({ post: null, done: skip });
  useEffect(() => {
    if (skip) return undefined;
    let live = true;
    setState({ post: null, done: false });
    getJson(`/journal/${slug}.json`)
      .then((p) => (p?.body ? p : getJson(`${API}/${slug}`)))
      .then((p) => { if (live) setState({ post: p?.body ? withDate(p) : null, done: true }); });
    return () => { live = false; };
  }, [slug, skip]);
  return state;
};
